import store from '~/store'

export default (to, from, next) => {
  if (!store.getters['auth/check']) {
    next({ name: 'login' })
  } else {
    var roles = store.getters['auth/roles'];
    if (roles) {
      var roleNames = _.map(roles, (r) => r.name)
      if (_.includes(roleNames, 'Admin') || _.includes(roleNames, 'BlindedResearcher') || _.includes(roleNames, 'UnblindedResearcher')) {
        return next()
      }
    } else {
      next({ name: 'welcome' })
    }
  }
}
